import { createSelector } from "@reduxjs/toolkit"

const selectLobbies = (state) => state.lobby.lobbies

export const selectLobby = createSelector([selectLobbies], (lobbies) => (lobbies.length > 0 ? lobbies[0] : null))

export const selectChatMessages = (state) => state.lobby.chatMessages

/* The room put this account out and nobody is navigating: the lobby route takes the player home. */
export const selectSentHome = (state) => Boolean(state.lobby.sentHome)
